import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { chain, AddProductLines, AddAttributeValueFilters } from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(
    chain,
    AddProductLines,
    props => {
        const currentFilters = props.getState().pages.productList.productFilters;
        props.result.productLineIds = currentFilters.productLineIds;

        const isYearMakeModelFilter = props.parameter.additionalExpands?.includes("yearMakeModelFilter");

        if (props.parameter.productLineIds) {
            if (isYearMakeModelFilter) {
                props.result.productLineIds = props.parameter.productLineIds;
            } else {
                props.result.productLineIds = props.parameter.productLineIds.concat(
                    props.result.productLineIds || []
                );
            }
        }

    },
);

replaceInChain(
    chain,
    AddAttributeValueFilters,
    props => {
       
        const currentFilters = props.getState().pages.productList.productFilters;
        props.result.attributeValueIds = currentFilters.attributeValueIds;
        const isYearMakeModelFilter = props.parameter.additionalExpands?.includes("yearMakeModelFilter");
        if (props.parameter.attributeValueIds) {
            if (isYearMakeModelFilter) {
                props.result.attributeValueIds = props.parameter.attributeValueIds;
            } else {
                props.result.attributeValueIds = props.parameter.attributeValueIds.concat(props.result.attributeValueIds || []);
            }
        }
    }
);
